import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { allowedDocumentMimeTypes } from "@/constants";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DropDownFile',
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "Select file",
    },
    uploadNewItem: {
      type: String,
      default: "Upload New File",
    },
    owner: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
    },
  },
  emits: ["deleteFile", "uploadFile", "changeSelectFile"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;
  const imgType = allowedDocumentMimeTypes.join(", ");

  const dropDownValue = computed(() => {
    return props.modelValue ? props.modelValue : props.placeholder;
  });

  function deleteFile() {
    emit("deleteFile");
  }

const __returned__ = { props, emit, imgType, dropDownValue, deleteFile, computed, DropDown, get allowedDocumentMimeTypes() { return allowedDocumentMimeTypes } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})